"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: quiz/survey-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fquiz%2Fsurvey-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyServiceClient = exports.GetOnboardingInterestTypeResponse = exports.GetOnboardingInterestTypeRequest = exports.ClearSurveyUserChoicesResponse = exports.ClearSurveyUserChoicesRequest = exports.UpdateSurveyUserChoicesResponse = exports.UpdateSurveyUserChoicesRequest = exports.GetSurveyResponse = exports.GetSurveyRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const onboarding_interest_type_1 = require("./onboarding-interest-type");
const survey_1 = require("./survey");
const survey_type_1 = require("./survey-type");
const protobufPackage = 'com.step.quiz.proto';
function createBaseGetSurveyRequest() {
    return { surveyType: survey_type_1.SurveyType.INVALID_SURVEY_TYPE };
}
exports.GetSurveyRequest = {
    fromJSON(object) {
        const message = {
            surveyType: isSet(object.surveyType)
                ? (0, survey_type_1.surveyTypeFromJSON)(object.surveyType)
                : survey_type_1.SurveyType.INVALID_SURVEY_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.surveyType !== survey_type_1.SurveyType.INVALID_SURVEY_TYPE) {
            obj.surveyType = (0, survey_type_1.surveyTypeToJSON)(message.surveyType);
        }
        return obj;
    },
    create(base) {
        return exports.GetSurveyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetSurveyRequest();
        message.surveyType = object.surveyType ?? survey_type_1.SurveyType.INVALID_SURVEY_TYPE;
        return message;
    },
};
function createBaseGetSurveyResponse() {
    return { survey: undefined };
}
exports.GetSurveyResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.survey)) {
            message.survey = survey_1.Survey.fromJSON(object.survey);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.survey !== undefined) {
            obj.survey = survey_1.Survey.toJSON(message.survey);
        }
        return obj;
    },
    create(base) {
        return exports.GetSurveyResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetSurveyResponse();
        message.survey = (object.survey !== undefined && object.survey !== null)
            ? survey_1.Survey.fromPartial(object.survey)
            : undefined;
        return message;
    },
};
function createBaseUpdateSurveyUserChoicesRequest() {
    return { surveyId: '', questionId: '', choiceIds: [] };
}
exports.UpdateSurveyUserChoicesRequest = {
    fromJSON(object) {
        const message = {
            surveyId: isSet(object.surveyId) ? globalThis.String(object.surveyId) : '',
            questionId: isSet(object.questionId) ? globalThis.String(object.questionId) : '',
            choiceIds: globalThis.Array.isArray(object?.choiceIds)
                ? object.choiceIds.map((e) => globalThis.String(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.surveyId !== '') {
            obj.surveyId = message.surveyId;
        }
        if (message.questionId !== '') {
            obj.questionId = message.questionId;
        }
        if (message.choiceIds?.length) {
            obj.choiceIds = message.choiceIds;
        }
        return obj;
    },
    create(base) {
        return exports.UpdateSurveyUserChoicesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateSurveyUserChoicesRequest();
        message.surveyId = object.surveyId ?? '';
        message.questionId = object.questionId ?? '';
        message.choiceIds = object.choiceIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseUpdateSurveyUserChoicesResponse() {
    return { survey: undefined };
}
exports.UpdateSurveyUserChoicesResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.survey)) {
            message.survey = survey_1.Survey.fromJSON(object.survey);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.survey !== undefined) {
            obj.survey = survey_1.Survey.toJSON(message.survey);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateSurveyUserChoicesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateSurveyUserChoicesResponse();
        message.survey = (object.survey !== undefined && object.survey !== null)
            ? survey_1.Survey.fromPartial(object.survey)
            : undefined;
        return message;
    },
};
function createBaseClearSurveyUserChoicesRequest() {
    return { surveyId: '', questionId: '' };
}
exports.ClearSurveyUserChoicesRequest = {
    fromJSON(object) {
        const message = {
            surveyId: isSet(object.surveyId) ? globalThis.String(object.surveyId) : '',
            questionId: isSet(object.questionId) ? globalThis.String(object.questionId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.surveyId !== '') {
            obj.surveyId = message.surveyId;
        }
        if (message.questionId !== '') {
            obj.questionId = message.questionId;
        }
        return obj;
    },
    create(base) {
        return exports.ClearSurveyUserChoicesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseClearSurveyUserChoicesRequest();
        message.surveyId = object.surveyId ?? '';
        message.questionId = object.questionId ?? '';
        return message;
    },
};
function createBaseClearSurveyUserChoicesResponse() {
    return { survey: undefined };
}
exports.ClearSurveyUserChoicesResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.survey)) {
            message.survey = survey_1.Survey.fromJSON(object.survey);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.survey !== undefined) {
            obj.survey = survey_1.Survey.toJSON(message.survey);
        }
        return obj;
    },
    create(base) {
        return exports.ClearSurveyUserChoicesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseClearSurveyUserChoicesResponse();
        message.survey = (object.survey !== undefined && object.survey !== null)
            ? survey_1.Survey.fromPartial(object.survey)
            : undefined;
        return message;
    },
};
function createBaseGetOnboardingInterestTypeRequest() {
    return {};
}
exports.GetOnboardingInterestTypeRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetOnboardingInterestTypeRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetOnboardingInterestTypeRequest();
        return message;
    },
};
function createBaseGetOnboardingInterestTypeResponse() {
    return { type: onboarding_interest_type_1.OnboardingInterestType.INVALID_ONBOARDING_INTEREST_TYPE };
}
exports.GetOnboardingInterestTypeResponse = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? (0, onboarding_interest_type_1.onboardingInterestTypeFromJSON)(object.type)
                : onboarding_interest_type_1.OnboardingInterestType.INVALID_ONBOARDING_INTEREST_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== onboarding_interest_type_1.OnboardingInterestType.INVALID_ONBOARDING_INTEREST_TYPE) {
            obj.type = (0, onboarding_interest_type_1.onboardingInterestTypeToJSON)(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.GetOnboardingInterestTypeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetOnboardingInterestTypeResponse();
        message.type = object.type ?? onboarding_interest_type_1.OnboardingInterestType.INVALID_ONBOARDING_INTEREST_TYPE;
        return message;
    },
};
/**
 * Service API for Survey service.
 */
class SurveyServiceClient {
    rpc;
    name = 'com.step.quiz.proto.SurveyService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/survey';
    methods = [{
            name: 'GetSurvey',
            requestType: exports.GetSurveyRequest,
            responseType: exports.GetSurveyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UpdateSurveyUserChoices',
            requestType: exports.UpdateSurveyUserChoicesRequest,
            responseType: exports.UpdateSurveyUserChoicesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'ClearSurveyUserChoices',
            requestType: exports.ClearSurveyUserChoicesRequest,
            responseType: exports.ClearSurveyUserChoicesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetOnboardingInterestType',
            requestType: exports.GetOnboardingInterestTypeRequest,
            responseType: exports.GetOnboardingInterestTypeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Get a survey by type.
     */
    getSurvey(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update user choices for a survey.
     */
    updateSurveyUserChoices(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Clear user choices for a survey.
     */
    clearSurveyUserChoices(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get user onboarding interest type.
     */
    getOnboardingInterestType(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.SurveyServiceClient = SurveyServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=survey-service.js.map